module.exports = __webpack_public_path__ + "img/易麦斯.9a6a3206.png";